import { Outlet, Navigate, useLocation } from "react-router-dom";

export default function LogoOnlyLayout() {
  const { pathname } = useLocation();

  if (localStorage.getItem("token") && !pathname.match("/WorkoutDisplay")) {
    return <Navigate to="/dashboard"> </Navigate>;
  }
  return <Outlet />;
}
